import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-about-us',
  templateUrl: './landing-about-us.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-about-us.component.scss']
})
export class LandingAboutUsComponent {

}
